"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
function Paragraph(_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    var prefix = ConfigProvider_1.usePrefix('paragraph');
    return react_1.default.createElement("p", tslib_1.__assign({ className: classnames_1.default(prefix, className) }, props));
}
exports.Paragraph = Paragraph;
//# sourceMappingURL=index.js.map